"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostVisitor = void 0;
const ast_1 = require("@wapc/widl/ast");
const helpers_1 = require("./helpers");
const utils_1 = require("../utils");
const constant_1 = require("./constant");
class HostVisitor extends ast_1.BaseVisitor {
    constructor(writer) {
        super(writer);
    }
    visitOperation(context) {
        if (!utils_1.shouldIncludeHostCall(context)) {
            return;
        }
        if (context.config.hostPreamble != true) {
            const className = context.config.hostClassName || "Host";
            this.write(`type ${className} struct {
\tbinding string
}

func New${className}(binding string) *${className} {
\treturn &${className}{
\t\tbinding: binding,
\t}
}\n`);
            context.config.hostPreamble = true;
        }
        const className = context.config.hostClassName || "Host";
        this.write(`\n`);
        const operation = context.operation;
        this.write(utils_1.formatComment("    // ", operation.description));
        this.write(`func (h *${className}) ${helpers_1.capitalize(operation.name.value)}(`);
        operation.parameters.map((param, index) => {
            if (index > 0) {
                this.write(`, `);
            }
            this.write(`${helpers_1.parameterName(param.name.value)} ${helpers_1.expandType(param.type, undefined, true, false)}`);
        });
        this.write(`) `);
        const retVoid = helpers_1.isVoid(operation.type);
        if (!retVoid) {
            this.write(`(${helpers_1.expandType(operation.type, undefined, true, false)}, error)`);
        }
        else {
            this.write(`error`);
        }
        this.write(` {\n`);
        let defaultVal = "";
        let defaultValWithComma = "";
        if (!retVoid) {
            defaultVal = helpers_1.defaultValueForType(operation.type);
            defaultValWithComma = defaultVal + ", ";
        }
        if (operation.parameters.length == 0) {
            if (!retVoid) {
                this.write(`payload, err := `);
            }
            else {
                this.write(`_, err := `);
            }
            this.write(`wapc.HostCall(h.binding, ${helpers_1.strQuote(context.namespace.name.value)}, ${helpers_1.strQuote(operation.name.value)}, []byte{})\n`);
        }
        else if (operation.isUnary()) {
            const unaryParam = operation.unaryOp();
            if (helpers_1.isObject(unaryParam.type)) {
                this.write(`inputBytes, err := msgpack.ToBytes(&${unaryParam.name.value})\n`);
            }
            else {
                const codecFunc = constant_1.codecFuncs.get(unaryParam.type.name.value);
                this.write(`inputBytes, err := msgpack.${codecFunc}(${unaryParam.name.value})\n`);
            }
            this.write(`if err != nil {
        return ${defaultValWithComma}err
      }\n`);
            if (!retVoid) {
                this.write(`payload, err := `);
            }
            else {
                this.write(`_, err = `);
            }
            this.write(`wapc.HostCall(h.binding, ${helpers_1.strQuote(context.namespace.name.value)}, ${helpers_1.strQuote(operation.name.value)}, inputBytes)\n`);
        }
        else {
            this.write(`inputArgs := ${helpers_1.fieldName(operation.name.value)}Args{\n`);
            operation.parameters.map((param) => {
                const paramName = param.name.value;
                this.write(`  ${helpers_1.fieldName(paramName)}: ${helpers_1.parameterName(paramName)},\n`);
            });
            this.write(`}\n`);
            this.write(`inputBytes, err := msgpack.ToBytes(&inputArgs)
      if err != nil {
        return ${defaultValWithComma}err
      }\n`);
            if (!retVoid) {
                this.write(`payload, err := `);
            }
            else {
                this.write(`_, err = `);
            }
            this.write(`wapc.HostCall(
      h.binding,
      ${helpers_1.strQuote(context.namespace.name.value)},
      ${helpers_1.strQuote(operation.name.value)},
      inputBytes,
    )\n`);
        }
        if (!retVoid) {
            this.write(`if err != nil {
        return ${defaultValWithComma}err
      }\n`);
            this.write(`decoder := msgpack.NewDecoder(payload)\n`);
            if (helpers_1.isObject(operation.type)) {
                this.write(`return Decode${helpers_1.expandType(operation.type, undefined, false, helpers_1.isReference(operation.annotations))}(&decoder)\n`);
            }
            else {
                var resultVar = "";
                if (operation.type instanceof ast_1.Optional) {
                    resultVar = "result";
                    this.write(`var result ${helpers_1.expandType(operation.type, undefined, true, helpers_1.isReference(operation.annotations))}\n`);
                }
                this.write(`${helpers_1.read(true, resultVar, true, defaultVal, operation.type, false, helpers_1.isReference(operation.annotations))}`);
                if (resultVar != "") {
                    this.write(`return ${resultVar}, err\n`);
                }
            }
        }
        else {
            this.write(`return err\n`);
        }
        this.write(`}\n`);
        super.triggerOperation(context);
    }
    visitAllOperationsAfter(context) {
        if (context.config.hostPreamble == true) {
            delete context.config.hostPreamble;
        }
        super.triggerAllOperationsAfter(context);
    }
}
exports.HostVisitor = HostVisitor;
//# sourceMappingURL=host_visitor.js.map